import React from "react";
import Dashboard from "../Dashboard";

const Support = () => {
  return <Dashboard>Support page</Dashboard>;
};

export default Support;
